import { observable, action } from "mobx";
import PhotoEditingJobRepository from "../repository/PhotoEditing/PhotoEditingJobRepository";
import PhotoEditingJob from "../models/PhotoEditing/PhotoEditingJob";

const pageIndexes = {
  HOME_PAGE: 0,
  CREATE_JOB_PAGE: 1,
  UPLOAD_PAGE: 2,
  REVIEW_IMAGES_PAGE: 3,
  REVIEW_JOB_PAGE: 4,
  VIEW_JOB_PAGE: 5,
};

class TourPhotoEditing {
  @observable currentPageIndex = 0;

  // Used for navigating thru pages that show one Job (upload, review, view pages, etc)
  @observable scopedPhotoEditingJobId = null;

  photoEditingJobRepository = null;

  constructor() {
    this.photoEditingJobRepository = new PhotoEditingJobRepository();
  }

  @action
  loadPhotoEditingJob(photoEditingJobId) {
    return this.photoEditingJobRepository
      .fetchOne(photoEditingJobId)
      .then(response => {
        const photoEditingJob = new PhotoEditingJob(response.data.photoEditingJob);
        this.onViewJob(photoEditingJob);
      })
      .catch(() => {
        // no-op. We could show an alert but it might be difficult for the user to know
        // that the error happened because of an invalid job id in the url's query string.
        // See NEST-529.
      });
  }

  // Navigation thru components

  @action
  showHomePage() {
    this.currentPageIndex = pageIndexes.HOME_PAGE;
  }

  @action
  showCreateJobPage() {
    this.currentPageIndex = pageIndexes.CREATE_JOB_PAGE;
  }

  @action
  showUploadPage() {
    this.currentPageIndex = pageIndexes.UPLOAD_PAGE;
  }

  @action
  showReviewImagesPage() {
    this.currentPageIndex = pageIndexes.REVIEW_IMAGES_PAGE;
  }

  @action
  showReviewJobPage() {
    this.currentPageIndex = pageIndexes.REVIEW_JOB_PAGE;
  }

  @action
  showViewJobPage() {
    this.currentPageIndex = pageIndexes.VIEW_JOB_PAGE;
  }

  @action
  showPage(page) {
    switch (page) {
      case "HOME_PAGE":
        this.showHomePage();
        break;
      case "UPLOAD_PAGE":
        this.showUploadPage();
        break;
      case "REVIEW_IMAGES_PAGE":
        this.showReviewImagesPage();
        break;
      case "REVIEW_JOB_PAGE":
        this.showReviewJobPage();
        break;
      case "VIEW_JOB_PAGE":
        this.showViewJobPage();
        break;
      default:
        throw new Error(`Unknown navigation page: ${page}`);
    }
  }

  @action
  onViewJob(photoEditingJob) {
    this.scopedPhotoEditingJobId = photoEditingJob.photoEditingJobId;

    if (photoEditingJob.isStatusInCreation && photoEditingJob.photoEditingImages.length === 0) {
      // Go to upload page if the job is in creation and no images yet.
      this.showUploadPage();
    } else if (photoEditingJob.isStatusInCreation) {
      // Go to review images page if the job is in creation.
      this.showReviewImagesPage();
    } else {
      // Go to view job if the job is in processing or done.
      this.showViewJobPage();
    }
  }

  // After a job is created in the CreateJobPage
  @action
  photoEditingJobCreated(photoEditingJob) {
    this.scopedPhotoEditingJobId = photoEditingJob.photoEditingJobId;
    this.showUploadPage();
  }
}

export default TourPhotoEditing;
